module.exports = __webpack_public_path__ + "img/UI_shouji_buttonP_01_ff316ed2d.png";